// English dictionary — assembled from per-domain section files.
// en.js and es.js must keep IDENTICAL key trees. Values may be strings,
// template functions (for interpolation), arrays of objects, or JSX nodes.
import publicLang from "./en.public";
import funnelLang from "./en.funnel";
import dashboardLang from "./en.dashboard";
import toolsLang from "./en.tools";
import miscLang from "./en.misc";
import fiftyoffLang from "./en.fiftyoff";

const en = {
  locale: "en-US",
  ...publicLang,
  ...funnelLang,
  ...dashboardLang,
  ...toolsLang,
  ...miscLang,
  ...fiftyoffLang,
};

export default en;
